import { ProtectedRoute } from '../components/ProtectedRoute';
import StakeholderLanding from './StakeholderLanding';

export default function ProtectedStakeholderLanding() {
  return (
    <ProtectedRoute>
      <StakeholderLanding />
    </ProtectedRoute>
  );
}
